import axios from "axios";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { PaginationControl } from "react-bootstrap-pagination-control";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import Swal from "sweetalert2";

import { refresh } from "../../../store/adminSlice";
import OrderItem from "./order-item";

const AutoOrderTable = ({ myData, hideFields, apiLink }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState({});
  const [myRows, setMyRows] = useState([]);
  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [item, setItem] = useState({});
  const [orderEdit, setOrderEdit] = useState(false);
  // const [orderItem, setOrderItem] = useState({});
  // const [updateItem, setUpdateItem] = useState(false);

  const buttonStatus = {
    success: "re order",
    pending: "send order",
    failed: "Order Canceled Only",
    canceled: "order",
    holding: "order",
    done_manual: "re order",
  };

  const toggle = (order = {}) => {
    setItem(order);
    setModal(!modal);
  };
  const item_per_page = 50;

  useEffect(() => setData(myData), [myData]);

  const Capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  let columns = [];

  if (myData?.results?.length > 0) {
    for (const key in myData.results[0]) {
      if (!hideFields.includes(key)) {
        columns.push(Capitalize(key.toString()));
      }
    }

    columns.push("Actions");
  } else {
    columns.push("Sorry, there is no data to show.");
  }

  // const handelDelete = (id) => {
  //  Swal.fire({
  //     title: "Do you want to delete this item?",
  //     showDenyButton: true,
  //     showCancelButton: true,
  //     confirmButtonText: "Delete",
  //     denyButtonText: `Don't Delete`,
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       axios
  //         .delete(`/alibaba/api/v1/orderItem/${id}/`)
  //         .then(() => Swal.fire(`Deleted!`, "", "success"))
  //         .catch((err) => {
  //           if (err.response?.status === 401 && Cookies.get("logss")) {
  //             dispatch(refresh()).then(() => handelDelete(id));
  //           } else if (err.response?.status === 401 && !Cookies.get("logss")) {
  //             navigate("/");
  //           } else {
  //             toast.error("Error occurred");
  //           }
  //         });
  //     } else if (result.isDenied) {
  //       Swal.fire("Order did not canceled", "", "info");
  //     }
  //   });
  // };

  const handleAutoOrder = async (id) => {
    Swal.fire({
      title: "Do you want to send the order?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Send",
      denyButtonText: `Don't send`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        await axios
          .post("/alibaba/api/v1/crossOrder/", { wege_order_id: id })
          .then(({ data }) => {
            Swal.fire({
              icon: data?.failed_orders ? "error" : "success",
              title: data?.failed_orders ? "Oops..." : "success",
              text: data?.failed_orders
                ? data.failed_orders[0]?.message
                : data.message,
              // footer: '<a href="#">Why do I have this issue?</a>'
            });
          })
          .catch((err) => {
            if (err.response?.status === 401 && Cookies.get("logss")) {
              dispatch(refresh()).then(() => handleAutoOrder(id));
            } else if (err.response?.status === 401 && !Cookies.get("logss")) {
              navigate("/");
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: err?.response?.data?.message || err.message,
              });
            }
          });
      } else if (result.isDenied) {
        Swal.fire("Order did not send", "", "info");
      }
    });
  };

  const handleReAutoOrder = async (id) => {
    Swal.fire({
      title: "Do you want to send the order again?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Send",
      denyButtonText: `Don't send`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        await axios
          .post("/alibaba/api/v1/reOrderCrossOrder/", {
            alibaba_order_id: id,
          })
          .then((data) => {
            Swal.fire({
              icon: data?.response?.status === 200 ? "success" : "error",
              title: data?.response?.status === 200 ? "success" : "FAILED",
              text: data.message,
              // footer: '<a href="#">Why do I have this issue?</a>'
            });
          })
          .catch((err) => {
            if (err.response?.status === 401 && Cookies.get("logss")) {
              dispatch(refresh()).then(() => handleReAutoOrder(id));
            } else if (err.response?.status === 401 && !Cookies.get("logss")) {
              navigate("/");
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: err?.response?.data?.message || err.message,
              });
            }
          });
      } else if (result.isDenied) {
        Swal.fire("Order did not send", "", "info");
      }
    });
  };

  const handleCanceledOrder = async (id) => {
    Swal.fire({
      title: "Do you want to re-order the canceled only ?",
      text: "if you edited the item you have to change order status (done manual) to re-order all again",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Send Canceled",
      denyButtonText: `wait i will edit status`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        await axios
          .post("/alibaba/api/v1/reorderCanceledSuborders/", {
            wege_order_id: id,
          })
          .then((data) => {
            Swal.fire({
              icon: data?.response?.status === 200 ? "success" : "error",
              title: data?.response?.status === 200 ? "success" : "FAILED",
              text: data.message,
              // footer: '<a href="#">Why do I have this issue?</a>'
            });
          })
          .catch((err) => {
            if (err.response?.status === 401 && Cookies.get("logss")) {
              dispatch(refresh()).then(() => handleCanceledOrder(id));
            } else if (err.response?.status === 401 && !Cookies.get("logss")) {
              navigate("/");
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: err?.response?.data?.message || err.message,
              });
            }
          });
      } else if (result.isDenied) {
        Swal.fire("Order did not send", "", "info");
      }
    });
  };

  const handleCancelAutoOrder = async (id) => {
    Swal.fire({
      title: "Do you want to cancel this order?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Send",
      denyButtonText: `Don't send`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        await axios
          .post("/alibaba/api/v1/cancelCrossOrder/", { order_id: id })
          .then((data) => {
            Swal.fire({
              icon: data?.response?.status === 200 ? "success" : "error",
              title: data?.response?.status === 200 ? "success" : "FAILED",
              text: data.message,
              // footer: '<a href="#">Why do I have this issue?</a>'
            });
          })
          .catch((err) => {
            if (err.response?.status === 401 && Cookies.get("logss")) {
              dispatch(refresh()).then(() => handleCancelAutoOrder(id));
            } else if (err.response?.status === 401 && !Cookies.get("logss")) {
              navigate("/");
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: err?.response?.data?.message || err.message,
              });
            }
          });
      } else if (result.isDenied) {
        Swal.fire("Order did not canceled", "", "info");
      }
    });
  };

  useEffect(() => {
    let collect = data?.results?.map((el, i) => {
      return (
        <tr key={i}>
          {Object.keys(el).map((key) => {
            if (!hideFields.includes(key)) {
              return (
                <td key={key} className="text-center">
                  {key === "visible" ? (
                    el[key] === false ? (
                      "NO"
                    ) : (
                      "YES"
                    )
                  ) : key === "user" ? (
                    el[key].email
                  ) : key === "status" ? (
                    el[key] === "success" ? (
                      <span className="text-success">{el[key]}</span>
                    ) : (
                      <span className="text-danger">{el[key]}</span>
                    )
                  ) : key === "note" ? (
                    <i
                      class="fa fa-commenting"
                      aria-hidden="true"
                      role="button"
                      title={el[key]}
                    ></i>
                  ) : key === "failure_reason" ? (
                    <i
                      class="fa fa-commenting"
                      aria-hidden="true"
                      role="button"
                      title={el[key]}
                    ></i>
                  ) : (
                    el[key]
                  )}
                </td>
              );
            }

            return null;
          })}

          <td key={i} className="text-center">
            <div className="d-flex">
              <span
                className="btn btn-info btn-sm btn-edit mb-0 b-r-4 me-2"
                type="button"
                title="reOrder"
                onClick={() => {
                  handleReAutoOrder(el.id);
                }}
              >
                <i className="fa fa-paper-plane text-white"></i>
              </span>
              <span
                className="btn btn-secondary btn-sm btn-edit mb-0 b-r-4 me-2"
                type="button"
                onClick={() => toggle(el)}
              >
                <i className="fa fa-eye"></i>
              </span>
              <span
                className="btn btn-warning btn-sm btn-delete mb-0 b-r-4 me-2"
                type="button"
                title="cancel order"
                onClick={() => handleCancelAutoOrder(el.order_id)}
              >
                <i className="fa fa-ban"></i>
              </span>
            </div>
          </td>
        </tr>
      );
    });

    setMyRows(collect);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, dispatch, hideFields, navigate]);

  let pageButtons = [];
  for (let i = 1; i <= Math.ceil(myData.count / 20); i++) {
    pageButtons.push(i);
  }

  const handlePagination = async (page) => {
    await axios
      .get(`${apiLink}${page}`)
      .then((res) => setData(res.data))
      .catch((err) => {
        if (err.response?.status === 401 && Cookies.get("logss")) {
          dispatch(refresh()).then(() => handlePagination(page));
        } else if (err.response?.status === 401 && !Cookies.get("logss")) {
          navigate("/");
        } else {
          toast.error("Error ocurred");
        }
      });
  };

  const handleButtonRequest = (order) => {
    switch (order.status) {
      case "success":
      case "done_manual":
        handleReAutoOrder(order.order_id);
        break;
      case "failed":
        handleCanceledOrder(order.wege_order_id);
        break;
      case "pending":
      case "canceled":
      case "holding":
        handleAutoOrder(order.wege_order_id);
        break;
      default:
        Swal.fire(
          "status UNKNOWN",
          "something weng wrong not in our status!!!",
          "question",
        );
        break;
    }
  };

  const updateOrderDetails = () => {
    setOrderEdit(false);
    delete item.user;
    delete item.items;
    axios
      .patch(`/alibaba/api/v1/crossOrder/${item.id}/`, item)
      .then((data) => {
        Swal.fire({
          icon: data?.status === 200 ? "success" : "error",
          title: data?.status === 200 ? "success" : "FAILED",
          text: data?.data?.message,
          // footer: '<a href="#">Why do I have this issue?</a>'
        });
      })
      .catch((err) => {
        if (err.response?.status === 401 && Cookies.get("logss")) {
          dispatch(refresh()).then(() => updateOrderDetails(item.id));
        } else if (err.response?.status === 401 && !Cookies.get("logss")) {
          navigate("/");
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err?.response?.data?.message || err.message,
          });
        }
      });
  };

  return (
    <div className="overflow-auto">
      <table className="table table-info table-striped table-hover w-100">
        <thead>
          <tr>
            {columns.map((v, k) => {
              return (
                <th key={k} scope="col" className="text-center">
                  {v}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>{myRows}</tbody>
      </table>

      <nav aria-label="Page navigation example text-center ">
        <div className="d-flex justify-content-between">
          <p className="d-flex">
            total pages :
            <span className="fw-bold">
              {Math.ceil(myData.count / item_per_page)}
            </span>
          </p>

          <PaginationControl
            page={page}
            between={5}
            total={myData.count}
            limit={item_per_page}
            changePage={(page) => {
              setPage(page);
              handlePagination(page);
            }}
            ellipsis={2}
          />

          <p className="d-flex">
            total rows :<span className="fw-bold">{myData.count}</span>
          </p>
        </div>
      </nav>
      {/* Modal */}
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{`Order NO:${item.id}`}</ModalHeader>
        <ModalBody>
          <ListGroup>
            <Container>
              <div className="d-flex justify-content-between">
                <h4>Order Details</h4>
                <div>
                  <button
                    className="btn btn-primary btn-sm btn-edit mb-0 b-r-4 me-2"
                    type="button"
                    title="edit order"
                    onClick={() =>
                      !orderEdit ? setOrderEdit(true) : updateOrderDetails()
                    }
                  >
                    <i
                      className={`fa fa-${
                        !orderEdit ? "edit" : "save"
                      } text-white`}
                    ></i>
                  </button>
                  {orderEdit && (
                    <button
                      className="btn btn-info btn-sm btn-delete mb-0 b-r-4 mx-1"
                      type="button"
                      title="cancel edit item"
                      onClick={() => setOrderEdit(false)}
                    >
                      <i className="fa fa-times text-white"></i>
                    </button>
                  )}
                </div>
              </div>
              <Row xs={2}>
                <ListGroupItem>
                  <span className="fw-bold">Local Order ID : </span>
                  {orderEdit ? (
                    <Input
                      type="text"
                      value={item.id}
                      onChange={(e) => setItem({ ...item, id: e.target.value })}
                    />
                  ) : (
                    item.id
                  )}
                </ListGroupItem>
                <ListGroupItem>
                  <span className="fw-bold">1688 Order_id : </span>
                  {orderEdit ? (
                    <Input
                      type="text"
                      value={item.order_id}
                      onChange={(e) =>
                        setItem({ ...item, order_id: e.target.value })
                      }
                    />
                  ) : (
                    item.order_id
                  )}
                </ListGroupItem>
                <ListGroupItem>
                  <span className="fw-bold">Order Amount : </span>
                  {orderEdit ? (
                    <Input
                      type="text"
                      value={item.order_amount}
                      onChange={(e) =>
                        setItem({ ...item, order_amount: e.target.value })
                      }
                    />
                  ) : (
                    item.order_amount
                  )}
                </ListGroupItem>
                <ListGroupItem>
                  <span className="fw-bold">Post Fee : </span>
                  {orderEdit ? (
                    <Input
                      type="text"
                      value={item.post_fee}
                      onChange={(e) =>
                        setItem({ ...item, post_fee: e.target.value })
                      }
                    />
                  ) : (
                    item.post_fee
                  )}
                </ListGroupItem>
                <ListGroupItem>
                  {orderEdit ? (
                    <>
                      <span className="fw-bold">status : </span>
                      <FormGroup row>
                        <Col sm={12}>
                          <Input
                            type="select"
                            value={item.status}
                            onChange={(e) =>
                              setItem({ ...item, status: e.target.value })
                            }
                            defaultChecked={item.status}
                          >
                            <option value="pending">pending</option>
                            <option value="success">success</option>
                            <option value="failed">failed</option>
                            <option value="canceled">canceled</option>
                            <option value="holding">holding</option>
                            <option value="done_manual">done manual</option>
                          </Input>
                        </Col>
                      </FormGroup>
                    </>
                  ) : (
                    <>item.status</>
                  )}
                </ListGroupItem>
                <ListGroupItem>
                  <span className="fw-bold">Created Time : </span>
                  {orderEdit ? (
                    <Input
                      type="text"
                      value={item.created_at}
                      onChange={(e) =>
                        setItem({ ...item, created_at: e.target.value })
                      }
                    />
                  ) : (
                    item.created_at
                  )}
                </ListGroupItem>
                <ListGroupItem>
                  {!orderEdit && (
                    <Link
                      to={`/orders/admin/${item.wege_order_id}`}
                      className="text-decoration-none text-dark"
                    >
                      <span className="fw-bold">Wege Order ID : </span>
                      {item?.wege_order_id}
                      <i
                        class="fa fa-external-link-square mx-1"
                        aria-hidden="true"
                      ></i>
                    </Link>
                  )}
                  {orderEdit && (
                    <>
                      <span className="fw-bold">Wege Order ID : </span>
                      <Input
                        type="text"
                        value={item.wege_order_id}
                        onChange={(e) =>
                          setItem({ ...item, wege_order_id: e.target.value })
                        }
                      />
                    </>
                  )}
                </ListGroupItem>
                <Col xs={12} className="p-0">
                  <ListGroupItem className="d-flex justify-content-between">
                    <span className="fw-bold">Failure Reason : </span>
                    {orderEdit ? (
                      <Input
                        type="text"
                        value={item.failure_reason}
                        className="flex-fill mx-1"
                        onChange={(e) =>
                          setItem({ ...item, failure_reason: e.target.value })
                        }
                      />
                    ) : (
                      item.failure_reason
                    )}
                  </ListGroupItem>
                </Col>
                <Col xs={12} className="p-0">
                  <ListGroupItem className="d-flex justify-content-between">
                    <span className="fw-bold">Note : </span>
                    {orderEdit ? (
                      <Input
                        type="text"
                        value={item.note}
                        className="flex-fill mx-1"
                        onChange={(e) =>
                          setItem({ ...item, note: e.target.value })
                        }
                      />
                    ) : (
                      item.note
                    )}
                  </ListGroupItem>
                </Col>
                <Col xs={12}>
                  <h4 className="py-2 text-dark">
                    <Link
                      to={`/user/profile/${item?.user?.id}`}
                      className="text-decoration-none text-dark"
                    >
                      User Details
                      <i
                        class="fa fa-external-link-square mx-1"
                        aria-hidden="true"
                      ></i>
                    </Link>
                  </h4>
                </Col>
                <ListGroupItem>
                  <span className="fw-bold">User Name : </span>
                  {item?.user?.username}
                </ListGroupItem>
                <ListGroupItem>
                  <span className="fw-bold">Email : </span>
                  {item?.user?.email}
                </ListGroupItem>
                <ListGroupItem>
                  <span className="fw-bold">Phone : </span>
                  {item?.user?.phone}
                </ListGroupItem>
                <Col xs={12}>
                  <h4 className="py-2 fw-bold"> Items </h4>
                </Col>
                {item?.items?.map((ele, i) => (
                  <OrderItem ele={ele} i={i} />
                ))}
              </Row>
            </Container>
          </ListGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleButtonRequest(item)}>
            {buttonStatus[item.status]}
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <ToastContainer />
    </div>
  );
};

export default AutoOrderTable;
